module.exports = __webpack_public_path__ + "static/media/motorhome_pink.b65c1acd.svg";